<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="100"
    >
    <template v-if="formValidate.video_work_type == 4">
      <FormItem label="方式">
        <RadioGroup v-model="formValidate.hj_type" type="button">
        <Radio label="混剪库中选择"></Radio>
        <Radio label="自定义上传"></Radio>
        </RadioGroup>
      </FormItem>

      <Card>
        <h3>已选择的视频片段</h3>
        <tables
          editable
          :columns="select_columns"
          v-model="formValidate.select_tableData"
          :loading="selectTableLoading"
        />
      </Card>
      <Card v-if="formValidate.hj_type=='混剪库中选择'">
        <h3>混剪库</h3>
        <tables
          editable
          :columns="columns"
          v-model="tableData"
          :loading="tableLoading"
          @on-select="selectionChange"
        />
      <Row class="page-con">
        <div class="page-bottom">
          <Page
            :current="page"
            :total="total"
            :page-size="pageSize"
            :page-size-opts="[10, 20, 30, 40, 100]"
            show-sizer
            show-elevator
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </Row>

      </Card>
    <template v-else>

      <FormItem label="上传混剪片段">
      </FormItem>

      <FormItem label="视频描述">
          <Row>
            <Col span="18">
              <Input type="textarea" v-model="formValidate.desc" placeholder="请填写"></Input>
            </Col>
          </Row>
      </FormItem>
        
      <FormItem label="视频">
        <input type="file" accept=".mp4,.mov"  @change="handleHJVideoFileChange" ref="videoFileInput" />
        <Button type="info" v-if='url_loadding' :loading="url_loadding">
            <span>上传中</span>
        </Button>
      </FormItem>
      <FormItem>
        <Button  @click="handleAdd" icon="md-add">确认</Button>
      </FormItem>

    </template>

    </template>
    <template v-else>
      <FormItem label="请上传视频文件" prop='video_path'>
        <input type="file" accept=".mp4,.mov"  @change="handleVideoFileChange" ref="handleVideoFile"/>
        <label class="search-label">{{show_video_path}}</label>
        <Button type="info" v-if='upload_loadding' :loading="upload_loadding">
              <span>上传中</span>
        </Button>
      </FormItem>

    </template>

      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import Tables from "_c/tables/table-only.vue";
import params from '../argu-page/params.vue'
import moment from 'moment';
const { v4: uuidv4 } = require('uuid');
import {uploadIdFile, uploadFile} from "@/api/uploadOss";
import {get_hj_library_list} from "@/api/data";

import config from '@/config'
const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro

export default {
  components: { 
    params,
    Tables
  },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      upload_loadding:false,
      tableLoading:false,
      selectTableLoading:false,
      url_loadding:false,
      classifyIds: [],
      tagIds:[],
      audioModelIds:[],
      show_face_path:'',
      show_video_path:'',
      resolving_power:'',
      update_id:true,
      page:1,
      pageSize:20,
      total:0,
      formValidate: {
        id: '',
        video_path:'',
        video_work_type:0,
        desc:'',
        url:'',
        id_url:'',
        hj_type:'混剪库中选择',
        select_tableData:[]
      },
      ruleValidate: {
        video_path: [
          {
            required: true,
            message: '换脸后的视频必须上传',
            trigger: 'blur'
          }
        ]
      },
      select_columns:[
        {type: 'index', title: '序号',width: 100, align: "center"},
        { title: "描述" , key: "video_desc", editable: true, align: "center"},
        { title: "分辨率" , key: "resolving_power", editable: true, align: "center"},
        { title: "视频" , key: "url", editable: true, align: "center",
          render: (h, params) => {
            return params.row.url != '' ?h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.download(baseUrl =='https://in.sinano-ai.com/api'?params.row.id_url:params.row.url);
                    },
                  },
                },
                "查看"
              )
            ]): h('span', '');
          }
        },
        {
          title: "操作",
          key: "handle", align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.handleDelete(params);
                    },
                  },
                },
                "删除"
              )
            ]);
          },
        }
      ],
      columns: [
      {type: 'selection', title: '选择',width: 100, align: "center"},
        { title: "描述" , key: "video_desc", editable: true, align: "center"},
        { title: "分辨率" , key: "resolving_power", editable: true, align: "center"},
        { title: "视频" , key: "url", editable: true, align: "center",
          render: (h, params) => {
            return params.row.url != '' ?h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.download(baseUrl =='https://in.sinano-ai.com/api'?params.row.id_url:params.row.url);
                    },
                  },
                },
                "查看"
              )
            ]): h('span', '');
          }
        }
      ],
      tableData: [],
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    selectionChange(row, selection){
      for (var i = 0; i < this.formValidate.select_tableData.length; i++){
        if (selection.id == this.formValidate.select_tableData[i].id){
          this.$Message.error('已添加');
          return
        }
      }

      this.formValidate.select_tableData.push({video_desc: selection.video_desc, url: selection.url, id_url: selection.id_url, id:selection.id, resolving_power:selection.resolving_power})
    },
    handleDelete(params){
      this.formValidate.select_tableData.splice(params.index, 1)
    },
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },
    handleSearch(){

      this.tableLoading = true
      let params = {
        page: this.page,
        pageSize: this.pageSize
      };
      get_hj_library_list(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.tableLoading = false
      });
    },
    download(url){
      window.open(url, '_blank');
    },
    async handleHJVideoFileChange(e){
      const file = e.target.files[0];
        if (!file) return;

      this.url_loadding = true
      this.upload_loadding = true
        // 上传文件
        let currentDate = moment().format('YYYY-MM-DD');
        const uuid = uuidv4()
        // 上传文件
        var name = file.name.substring(file.name.lastIndexOf('.'))
        var result = await uploadIdFile('short_video/' + currentDate + "/covert_audio/" + uuid + name, file);
        if (result == ''){
          this.$Message.error('上传失败');
          this.$refs.videoFileInput.value = ''
          this.url_loadding = false
          return
        }

        this.formValidate.id_url = result
        result = await uploadFile('short_video/' + currentDate + "/covert_audio/" + uuid + name, file);

        if (result == ''){
          this.$Message.error('上传失败');
          this.$refs.videoFileInput.value = ''
        }else{
          this.$Message.info('上传成功');
          this.formValidate.url = result
        }

        this.url_loadding = false
    },
    handleHJRemove(index){
      this.formValidate.hjVideoArray.splice(index, 1)
    },
    handleAdd(){

      if (this.formValidate.desc.length == 0){
        this.$Message.error('请填写视频描述');
        return
      }

      if (this.formValidate.url == 0){
        this.$Message.error('请上传视频片段');
        return
      }

      this.formValidate.select_tableData.push({video_desc: this.formValidate.desc, url: this.formValidate.url, id_url: this.formValidate.id_url, id:0})
    },
    setEditData(params){

      if (this.$refs.handleVideoFile != null)
        this.$refs.handleVideoFile.value = ''

      this.formValidate.id = params.id
      this.formValidate.video_path = params.output_video_path
      this.formValidate.video_work_type = params.covertAudio.translateText.checkSrtTask.shortVideoTask.short_video_work_type_id
      this.resolving_power = ""
      if (this.formValidate.video_work_type == 4){
        this.handleSearch()
      }

      this.formValidate.select_tableData = params.list
      this.update_id = params.covertAudio.translateText.checkSrtTask.shortVideoTask.upload_id
      if (params.output_video_path != null){
          var video_path_array = params.output_video_path.split("/")
          this.show_video_path = video_path_array[video_path_array.length - 1]
        }

    }, async handleVideoFileChange(e){
      try {
        const file = e.target.files[0];
        if (!file) return;

        this.formValidate.video_path = await this.uploadFile(file)
        if (this.formValidate.video_path != null){
            var org_video_array = this.formValidate.video_path.split("/")
            this.show_video_path = org_video_array[org_video_array.length - 1]
        }
  
      } catch (error) {
        this.$Message.error('上传失败');
        this.$refs.handleVideoFile.value = ''
      }
    },async uploadFile(file){

        this.upload_loadding = true
        // 上传文件
        let currentDate = moment().format('YYYY-MM-DD');
        const uuid = uuidv4()
        // 上传文件
        var name = file.name.substring(file.name.lastIndexOf('.'))
        var result = ""

        if (baseUrl =='https://in.sinano-ai.com/api'){
          result = await uploadIdFile('short_video/' + currentDate + "/covert_audio/" + uuid + name, file);
        }else{
          result = await uploadFile('short_video/' + currentDate + "/covert_audio/" + uuid + name, file);
        }
        if (result == ''){
          this.$Message.error('上传失败');
          this.$refs.handleVideoFile.value = ''
        }else{
          this.$Message.info('上传成功');
        }
        this.upload_loadding = false

        return result

    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
